import ProfileNonAcademicWork from './ProfileNonAcademicWork.component';

export default ProfileNonAcademicWork;